var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUnlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_unlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.579,
    height: 20,
    viewBox: "0 0 20.579 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "link_off_FILL0_wght400_GRAD0_opsz48",
    d: "M80.3-835.919l-1.234-1.234a3.769,3.769,0,0,0,2.141-1.209,3.255,3.255,0,0,0,.856-2.242,3.4,3.4,0,0,0-1.033-2.494,3.4,3.4,0,0,0-2.494-1.033h-3.9v-1.511h3.9a4.855,4.855,0,0,1,3.564,1.474,4.855,4.855,0,0,1,1.474,3.564,4.713,4.713,0,0,1-.907,2.821A5.4,5.4,0,0,1,80.3-835.919Zm-3.929-3.929-1.511-1.511h2.544v1.511ZM81.917-830,63-848.917,64.083-850,83-831.083Zm-9.169-5.642H68.466a4.856,4.856,0,0,1-3.564-1.474,4.855,4.855,0,0,1-1.474-3.564,4.94,4.94,0,0,1,1.121-3.2,4.8,4.8,0,0,1,2.859-1.738l1.411,1.411h-.353a3.4,3.4,0,0,0-2.494,1.033,3.4,3.4,0,0,0-1.033,2.494,3.4,3.4,0,0,0,1.033,2.494,3.4,3.4,0,0,0,2.494,1.033h4.282ZM69.6-839.924v-1.511h1.99l1.511,1.511Z",
    transform: "translate(-63 850)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnlink);
export default __webpack_public_path__ + "static/media/icon-unlink.016e56936eb8123172395bf9b91cad92.svg";
export { ForwardRef as ReactComponent };